
import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Spinner,
  Button,
} from "reactstrap";
import axios from "axios";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import { useNavigate } from "react-router-dom";
import { FiLogOut } from "react-icons/fi";

const ExpenseHeader = () => {
 const navigate = useNavigate();
    const [userName, setUserName] = useState("");
 const handleLogout = () => {
  const confirmLogout = window.confirm("Are you sure you want to log out?");
  if (confirmLogout) {
    localStorage.removeItem("id");
    localStorage.removeItem("role");
    localStorage.removeItem("name");
    navigate("/expenseLogin");
  }
};

  useEffect(() => {
      // Example: fetch from localStorage or API
      const storedUser = localStorage.getItem("name");
      if (storedUser) {
        setUserName(storedUser);
      }
    }, []);
  
  return (
    <header className="dashboard-header shadow-sm">
      <Container
        fluid
        className="py-3 d-flex justify-content-between align-items-center"
      >
        <h3 className="m-0 fw-bold text-primary"> <a href="/expenseDashboard">Expense Dashboard</a></h3>
        <div className="d-flex align-items-center gap-3">
          <span className="fw-semibold text-dark">
            {userName || "User"}
          </span>
          
         <Button
  color="link"
  className="p-0 border-0 shadow-none"
  onClick={handleLogout}
  style={{ background: "transparent" }}
>
  <FiLogOut size={20} color="red" />
</Button>
        </div>
      </Container>
    </header>
    
   
  );
};

export default ExpenseHeader;









